
<template> 
    <div v-if="hasPermissaoInstrutor">
        <CardRh :processando="processando" :titulo="titulo" >  
            <KDataTable :reload="reloadDatatable" :config="config" @clicou_linha="selectModel( $event )" @tableatualizada="tableatualizada( $event )"  :pesquisar="false" v-if="instrutor" >  
                <th style="max-width:80px">Id</th>  
                <th style="max-width:80px">Nº</th>  
                <th>Pel</th> 
                <th>Data</th>
                <th>Início</th>
                <th>Fim</th>
                <th>Situação</th> 
                <th class="text-center coluna-acoes"  v-if="hasPermissao">Ações</th>   
                <template v-slot:filtros>  

                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                        <div class="mb-2">
                            <label for="DataMin" class="form-label">Data Mínima</label>
                            <input  @keyup="apertouEnter" @blur="refreshTable" v-model="data_min"  type="date" data-kt-docs-table-filter="DataMin" class="form-control form-control-solid " placeholder="Data Incorporacao Minima"/>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                        <div class="mb-2">
                            <label for="DataMax" class="form-label">Data Máxima</label>
                            <input  @keyup="apertouEnter" @blur="refreshTable"  v-model="data_max" type="date" data-kt-docs-table-filter="DataMax" class="form-control form-control-solid" placeholder="Data Incorporacao Minima"/>
                        </div> 
                    </div>   
                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-2" v-if="status">
                        <div class="mb-2"> 
                            <label  for="StatusAula" class="form-label">Status:</label>  
                            <Multiselect @change="refreshTable" :options="status_select" :searchable="true"  v-model="status_id" ></Multiselect>    
                        </div> 
                    </div> 
                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-2">
                        <div class="mb-2">
                            <label for="pelotao" class="form-label">Pelotao</label>
                            <input @keyup="apertouEnter" type="text" data-kt-docs-table-filter="pelotao" class="form-control form-control-solid" placeholder="Pelotão"/>
                        </div> 
                    </div> 
                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-2">
                        <div class="mb-2">
                            <label for="numero" class="form-label">Número</label>
                            <input @keyup="apertouEnter" type="text" data-kt-docs-table-filter="numero" class="form-control form-control-solid" placeholder="Número da aula"/>
                        </div> 
                    </div> 
                    
                    <input type="text" data-kt-docs-table-filter="StatusAula" v-model="status_id" hidden/> 
                    <input type="text" data-kt-docs-table-filter="instrutorCPF" v-model="instrutor.usuarioId" hidden/> 
                    <input type="text" data-kt-docs-table-filter="instrutorId" v-model="instrutor.id" hidden/> 
                
                </template> 
            </KDataTable>   
            <template v-slot:action v-if="instrutor"> 
                <router-link :to="{ name: 'instrutor_disciplina_index' , params: {  turmaId:instrutor.turma.id }  }" type="button" class="btn border border-secondary btn-sm btn-light btn-cadastrar-datatable"  >  
                    <i class="fa fa-reply"></i> Voltar  
                </router-link>
                <AlunosPdf :turma="instrutor.turma.id" :pelotao="instrutor.pelotao" v-if="instrutor" ></AlunosPdf> 
            </template> 

            <AulaPdf :aula="id_pdf"  :service="service"  :modal="modal_pdf" /> 

        </CardRh>
    </div>    
</template>

<script lang="ts"> 
	import IndexModelTable from '@/views/paginas/sigap/modelos/IndexModelTable.vue';    
    import CardRh from   "@/components/cards/ManzaCard.vue"
    import InstrutorService from   "@/service/v1/sigap/InstrutorService"  
    import AulaService from   "@/service/v1/sigap/AulaService"  
    import { Options  } from "vue-class-component";    
    import   SiteUtils   from '@/assets/ts/aplicacao/site'; 
    import KDataTable from   "@/components/datatable/newdatatable.vue" 
	import $ from "jquery";   
    import AlunosPdf from   "./_AlunosPdf.vue";
    import AulaPdf from   "./_PdfAula.vue";
    import { PerfilConfig } from "@/core/config/PerfisConfig"; 
    import Multiselect from '@vueform/multiselect'  
    
    @Options({
        name: "InstrutorIndexAulas",
        components: {  CardRh , KDataTable , AulaPdf , AlunosPdf, Multiselect },   
    }) 
    export default class InstrutorIndexAulas extends IndexModelTable {
        
        public instrutor: any = null; 
        public instrutorService = new InstrutorService(); 
        public status_id: any = 1
        public status: any = null; 
        public pelotao: any = null;
        public data_min: any = null;
        public data_max: any = null;

        public modal_pdf = 'modal_pdf_aula_professor'; 
        public id_pdf : any = null;


        get titulo( ): string {
            let texto = 'Aulas';
            if(this.instrutor) 
                texto = texto +  ' - ' + this.instrutor.disciplina.descricao ;
            if(this.instrutor && this.instrutor.turma) 
                texto = texto +   ' (' + this.instrutor.turma.descricao + ')' ;
            return texto;
        }

        get status_select(){
            if(this.status){
                return this.status.map((item) => { return { value:  item.id , label: item.nome } });   
            }
            return null;
        }
        
        public getStatus(){   
            this.processando = true ; 
            this.service.getStatus(    ) 
            .then(response => {   
                this.status =  JSON.parse(JSON.stringify( response ));   
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
            }); 
        } 

        get hasPermissao( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.Professor ] ,  this.perfis); 
        }

        public refreshTable(){ 
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable ; 
            }, 300); 
        }
         
        public apertouEnter(e){ 
            if(e.key === 'Enter' || e.keyCode === 13){
                this.refreshTable();
            }
        }
           
        get hasPermissaoInstrutor( ): boolean {
            return this.instrutor && this.instrutor.usuarioId == this.currentUser.id; 
        }

        async created(){   
            this.service = new AulaService();  
            this.getStatus(); 
            this.config.ajax = { 
                url: this.service.getApiUrl() + "/GetAllAulaProfessor" ,
                data: function ( d ) {   
                    const dados = {
                        "Skip": d.start,
                        "Take": d.length,
                        "DataMin": () => (document.querySelector('[data-kt-docs-table-filter="DataMin"]')! as HTMLInputElement).value ,
                        "DataMax": () => (document.querySelector('[data-kt-docs-table-filter="DataMax"]')! as HTMLInputElement).value , 
                        "instrutorCPF": () => (document.querySelector('[data-kt-docs-table-filter="instrutorCPF"]')! as HTMLInputElement).value , 
                        "instrutorId": () => (document.querySelector('[data-kt-docs-table-filter="instrutorId"]')! as HTMLInputElement).value , 
                        "status": () => (document.querySelector('[data-kt-docs-table-filter="StatusAula"]')! as HTMLInputElement).value , 
                        "pelotao": () => (document.querySelector('[data-kt-docs-table-filter="pelotao"]')! as HTMLInputElement).value , 
                        "numero": () => (document.querySelector('[data-kt-docs-table-filter="numero"]')! as HTMLInputElement).value , 
                        "search": d.search.value
                    }
                    return dados; 
                } 
            }; 

            this.config.columns = [ 
                { data:  'id',  name:  'id', searchable: false }, 
                { data:  'numero',  name:  'numero',  class: 'desktop' ,orderable: false, searchable: false }, 
                { data: 'aulaDisciplina', name: 'auladisciplina' , searchable: false}, 
                { data:  'data',  name:  'data', class:'desktop' , searchable: false}, 
                { data:  'inicio',  name:  'inicio', class:'desktop' , searchable: false}, 
                { data:  'fim',  name:  'fim', class:'desktop' , searchable: false}, 
                { data:  'status',  name:  'status' ,   searchable: false, class: 'text-center desktop'}, 
            ];
            this.config.columnDefs = [ 
                {
                    targets: 1,
                    render: function ( row, type, val, meta ) {  
                        return row +  '/' + (val.disciplina?.cargaHoraria ?? "")  ;  
                    }
                },  
                {
                    targets: 2,
                    render: function ( row, type, val, meta ) {   
                        return row != null ? row.pelotao : '';  
                    }
                },  
                {
                    targets: 3,
                    render: function ( row, type, val, meta ) {  
                        return SiteUtils.formatData( row )  ;
                    }
                },  
                {
                    targets: 6 ,
                    render: ( row, type, val, meta ) => {   
                        return row.nome ?? '';  
                    }, 
                } 
            ];
            if(this.hasPermissao){ 
                this.config.columns.push({ data: 'id', name: 'id'  , orderable: false, searchable: false , class: 'text-center' });
                this.config.columnDefs.push(
                    {
                        targets: 7 ,
                        render: ( row, type, val, meta ) => {  
                            let texto = '' ; 
                            let buttom = '' ;  
                            for (var key in val) {  buttom = buttom + ' data-' + key + '="'+ val[key] +'"'  } 
                            texto = texto + '<button class="btn btn-secondary btn-sm border border-pmes-danger" btn-pdf'+ buttom +'   data-bs-toggle="modal" data-bs-target="#' +
                            this.modal_pdf  + '" title="Pdf"><i class="fa fa-2x fa-file-pdf text-pmes-danger"></i></button>';  

                            if(val.status.id == 1  ){
                                texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-homologar '+ buttom +' title="Homologar"><i class="fa fa-gavel"></i></button>';  
                            } 
                            return texto;  
                        }, 
                    }
                );  
            }
            await this.buscaInstrutor();
        }   
        
        
        public async buscaInstrutor( ) {
            this.processando = true ;  
            await this.instrutorService.getModel(this.$route.params.instrutor ) 
            .then(response => {    
                this.instrutor =  JSON.parse(JSON.stringify( response ));  
                this.pelotao = this.instrutor.pelotao
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
            });  
        }
  
        public tableatualizada( event ) {   
            $('[btn-homologar]').click(  (btn) => {   
                let aula_id =   $(btn.currentTarget).data('id');   
                this.$router.push({ name: "instrutor_disciplina_aulas_validacao" ,   params: {  instrutor: this.instrutor.id , aula: aula_id  }  }) 
            });  

            $('[btn-pdf]').click(  (btn) => {   
                this.id_pdf =   null;
                setTimeout(() => {
                    this.id_pdf =   this.modelo != null ? this.modelo.id : null; 
                }, 100); 
            });  

        }  
 
        public selectModel( event ) {  
            this.modelo =   null; 
            this.modelo = event;
        }  

    } 
</script>

<style scoped> 
    .btn-sm{
        margin-left: 10px; 
        padding: 0.55rem 1.25rem;
    } 
    .registro-alteracao{
        text-align: right;
    }
    @media screen and (min-width: 1200px) { 
        .coluna-acoes{
            min-width:170px;
        }
    } 

</style>


<style>  
    .btn-sm i { 
        font-size: 1.5rem !important;
    } 
</style>